import { useMutation, gql } from "@apollo/client";

const VERIFY_PASSWORD_RESET_CODE = gql`
  mutation VerifyPasswordResetCode($email: String!, $code: String!) {
    verifyPasswordResetCode(email: $email, code: $code)
  }
`;

export const useVerifyPasswordResetCodeMutation = () => {
  const [verifyPasswordResetCode, { loading, error }] = useMutation(VERIFY_PASSWORD_RESET_CODE, {
    onError: (error) => {
      console.error("Error verifying password reset code:", error.message);
    },
  });

  const handleVerifyPasswordResetCode = async (email: string, code: string) => {
    try {
      const result = await verifyPasswordResetCode({
        variables: { email, code },
      });
      return { success: result.data?.verifyPasswordResetCode ?? false };
    } catch (error: any) {
      console.error("Error occurred during code verification:", error);
      return { 
        success: false, 
        error: error?.message || "Invalid or expired code. Please try again." 
      };
    }
  };

  return {
    handleVerifyPasswordResetCode,
    loading,
    error,
  };
};




















